import { atom } from 'jotai';
import { SelectItem } from '../types';

export const allTableSelectedDate = atom<string | null>(null);
export const allTableSelectedOPs = atom<SelectItem[]>([]);
export const allTableSelectedStatus = atom<SelectItem | null>(null);

export const pendingTsSelectedOPs = atom<SelectItem[]>([]);

/** When true, the Deal Owner pending list shows only timesheets delegated to the current viewer. */
export const pendingTsDelegatedOnly = atom<boolean>(false);

